import Api from './baseApi';

export default {
    getInventoryItems: (type) => {
        let url = '/api/inventory';
        if (type !== undefined && type !== null) url += `?type=${type}`;
        return Api.get(url);
    },
    getTotalHas: () => Api.get('/api/inventory/totalHas'),
    addKulce: (dto) => Api.post('/api/inventory/kulce', dto),
    addZiynet: (dto) => Api.post('/api/inventory/ziynet', dto),
    addDiger: (dto) => Api.post('/api/inventory/diger', dto),
    addTaki: (dto) => Api.post('/api/inventory/taki', dto),
    getJewelryItems: (status, search, size, weightRounded, purity, productName) => {
        let url = '/api/inventory/jewelry?v=1';
        if (status !== undefined && status !== null) url += `&status=${status}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        if (size) url += `&size=${encodeURIComponent(size)}`;
        if (weightRounded !== undefined && weightRounded !== null) url += `&weightRounded=${weightRounded}`;
        if (purity !== undefined && purity !== null && purity !== '') url += `&purity=${encodeURIComponent(purity)}`;
        if (productName) url += `&productName=${encodeURIComponent(productName)}`;
        return Api.get(url);
    },
    getJewelryTotalHas: (status, size, weightRounded, purity, productName) => {
        let url = '/api/inventory/jewelry/totalHas';
        const params = [];
        if (status !== undefined && status !== null) params.push(`status=${status}`);
        if (size) params.push(`size=${encodeURIComponent(size)}`);
        if (weightRounded !== undefined && weightRounded !== null) params.push(`weightRounded=${weightRounded}`);
        if (purity !== undefined && purity !== null && purity !== '') params.push(`purity=${encodeURIComponent(purity)}`);
        if (productName) params.push(`productName=${encodeURIComponent(productName)}`);
        if (params.length) url += '?' + params.join('&');
        return Api.get(url);
    },
    deleteJewelryItem: (id) => Api.delete(`/api/inventory/jewelry/${id}`),
    updateJewelryStatus: (id, dto) => Api.patch(`/api/inventory/jewelry/${id}/status`, dto),
    // Sipariş barkod okuma
    resolveBarcode: (code) => Api.get(`/api/inventory/resolve-barcode?code=${encodeURIComponent(code)}`),
    previewOrderReading: (orderId, barcodes, claimBarcodes) => Api.post('/api/inventory/order-reading/preview', { orderId, barcodes, claimBarcodes }),
    confirmOrderReading: (orderId, barcodes, claimBarcodes) => Api.post('/api/inventory/order-reading/confirm', { orderId, barcodes, claimBarcodes }),

    // Tedarikçi (atölye/rafineri) alım mutabakatı
    getSupplierIntakeSummary: (params) => Api.get(`/api/inventory/supplier-intake/summary?${new URLSearchParams(params || {}).toString()}`),
    getSupplierIntakeMovements: (params) => Api.get(`/api/inventory/supplier-intake/movements?${new URLSearchParams(params || {}).toString()}`),
    getOpenSupplierIntakes: (supplierType, supplierId) => Api.get(`/api/inventory/supplier-intake/open?supplierType=${supplierType}&supplierId=${supplierId}`),
    getCanViewSupplierIntakeReconciliation: () => Api.get('/api/inventory/supplier-intake/can-view-reconciliation'),
    closeSupplierIntake: (supplierType, id, note) => Api.post(`/api/inventory/supplier-intake/${supplierType}/${id}/close`, { note }),
    reopenSupplierIntake: (supplierType, id, note) => Api.post(`/api/inventory/supplier-intake/${supplierType}/${id}/reopen`, { note }),
    receiveIntake: (dto) => Api.post('/api/inventory/supplier-intake/receive', dto),
    undoReceiveIntake: (batchId, note) => Api.post(`/api/inventory/supplier-intake/receive/${batchId}/undo`, { note }),
    getReconciliationHistory: (params) => Api.get(`/api/inventory/supplier-intake/history?${new URLSearchParams(params || {}).toString()}`),
    getSupplierIntakeReconciliation: (params) => Api.get(`/api/inventory/supplier-intake/reconciliation?${new URLSearchParams(params || {}).toString()}`),

    // Zimmet (consignment)
    zimmetAssign: (dto) => Api.post('/api/zimmet/assign', dto),
    zimmetReturn: (dto) => Api.post('/api/zimmet/return', dto),
    getAllZimmets: () => Api.get('/api/zimmet/all'),
    getMyZimmet: () => Api.get('/api/zimmet/my'),
    getKasa: () => Api.get('/api/zimmet/kasa'),
    getZimmetReconciliation: () => Api.get('/api/zimmet/reconciliation'),
    getZimmetCanView: () => Api.get('/api/zimmet/can-view'),

    // Borç (envanteri borç ver / geri al)
    borcLend: (dto) => Api.post('/api/borc/lend', dto),
    borcReturn: (dto) => Api.post('/api/borc/return', dto),
    getBorclar: (activeOnly) => Api.get(`/api/borc/all${activeOnly ? '?activeOnly=true' : ''}`),

    // Diğer Satışlar (manuel satış / iade)
    otherSaleSell: (dto) => Api.post('/api/othersale/sell', dto),
    otherSaleRefund: (dto) => Api.post('/api/othersale/refund', dto),
    getOtherSales: (activeOnly) => Api.get(`/api/othersale/all${activeOnly ? '?activeOnly=true' : ''}`),

    // Envanter tanımları (Takı/Külçe/Ziynet açılır listeleri)
    getDefinitions: (inventoryType, category) => {
        const params = [];
        if (inventoryType !== undefined && inventoryType !== null) params.push(`inventoryType=${inventoryType}`);
        if (category !== undefined && category !== null) params.push(`category=${category}`);
        let url = '/api/inventorydefinition';
        if (params.length) url += '?' + params.join('&');
        return Api.get(url);
    },
    createDefinition: (dto) => Api.post('/api/inventorydefinition', dto),
    updateDefinition: (id, dto) => Api.put(`/api/inventorydefinition/${id}`, dto),
    deleteDefinition: (id) => Api.delete(`/api/inventorydefinition/${id}`),

    // Diğer Zimmet Kalemleri kataloğu
    getOtherItems: () => Api.get('/api/otheritem'),
    createOtherItem: (dto) => Api.post('/api/otheritem', dto),
    updateOtherItem: (id, dto) => Api.put(`/api/otheritem/${id}`, dto),
    deleteOtherItem: (id) => Api.delete(`/api/otheritem/${id}`),

    // Ürün reçetesi (BOM)
    getProductComponents: (productId) => Api.get(`/api/products/${productId}/components`),
    saveProductComponents: (productId, items) => Api.put(`/api/products/${productId}/components`, items),
    getTakiKinds: () => Api.get('/api/inventory/taki-kinds'),
}
